import { render, staticRenderFns } from "./TransactionPerStallionOwnerCard.vue?vue&type=template&id=12c64f74&scoped=true&"
import script from "./TransactionPerStallionOwnerCard.vue?vue&type=script&lang=ts&"
export * from "./TransactionPerStallionOwnerCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c64f74",
  null
  
)

export default component.exports